import {
  selectCurrentHotelId,
  selectCurrentHotelName,
  selectLoggedinUserEmail,
  selectLoggedinUserName,
  selectLoggedinUserPhone
} from 'accessors'
import { useState } from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import dashboardApi from 'services/api/dashboard'
import LocalUserService from 'services/localUserService'

const userService = new LocalUserService()

const LoadingIndicator = ({
  show = true,
  inline,
  marginTop,
  className,
  white,
  longWaitingTreshold = 15
}) => {
  const [waitingForLongTime, setWaitingForLongTime] = useState(false)

  const uiSubsidiaryId = useSelector(selectCurrentHotelId)
  const uiSubsidiaryName = useSelector(selectCurrentHotelName)
  const uiDashboardSessionId = userService.getCurrentUserInfo()?.sessionId
  const uiUserName = useSelector(selectLoggedinUserName)
  const uiUserPhone = useSelector(selectLoggedinUserPhone)
  const uiUserEmail = useSelector(selectLoggedinUserEmail)

  useEffect(() => {
    let seconds = 0
    const timer = setInterval(function () {
      seconds++
      if (seconds > longWaitingTreshold) {
        clearInterval(timer)
        setWaitingForLongTime(true)
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [longWaitingTreshold])

  useEffect(() => {
    if (waitingForLongTime) {
      dashboardApi.log({
        level: 'Warn', // Error, Fatal, Debug, Info, Warn
        message: `User ${uiUserName} waiting for more than ${longWaitingTreshold} secs on ${document.location.pathname}`,
        additionalData: {
          uiSubsidiaryId,
          uiSubsidiaryName,
          uiDashboardSessionId,
          uiPath: document.location.pathname,
          uiUserName,
          uiUserPhone,
          uiUserEmail
        }
      })
    }
  }, [
    uiDashboardSessionId,
    uiSubsidiaryId,
    uiSubsidiaryName,
    uiUserEmail,
    uiUserName,
    uiUserPhone,
    waitingForLongTime,
    longWaitingTreshold
  ])

  return show ? (
    <div
      aria-label="loading"
      className={[
        `dashboard-loading ${inline && 'dashboard-loading--inline'}`,
        className ? className : ''
      ].join(' ')}
      style={{ marginTop: marginTop || 0 }}
    >
      <div className={['lds-ellipsis', white ? 'lds-ellipsis--white' : ''].join(' ')}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {waitingForLongTime && (
        <div style={{ fontSize: 14, display: 'flex', flexDirection: 'column' }}>
          This is taking longer than it should.{' '}
          <button
            style={{
              background: '#4079f5',
              color: 'white',
              fontSize: 13,
              borderRadius: 3,
              textDecoration: 'none',
              fontWeight: 500,
              height: 34,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 7
            }}
            onClick={() => document.location.reload()}
          >
            Reload Dashboard
          </button>
        </div>
      )}
    </div>
  ) : (
    ''
  )
}

export default LoadingIndicator
